(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function closeAll(except) {
      document.querySelectorAll('[data-delivery-estimate].is-open').forEach(function(el){
        if (el !== except) el.classList.remove('is-open');
        var btn = el.querySelector('.delivery-estimate__bar');
        var tip = el.querySelector('.delivery-estimate__tooltip');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (tip) tip.setAttribute('aria-hidden', 'true');
      });
    }

    document.addEventListener('click', function(e){
      var root = e.target.closest('[data-delivery-estimate]');
      if (!root) return closeAll();

      var btn = e.target.closest('.delivery-estimate__bar');
      if (!btn) return; // click dans le tooltip -> ne ferme pas

      var isOpen = root.classList.toggle('is-open');
      closeAll(isOpen ? root : null);

      var tip = root.querySelector('.delivery-estimate__tooltip');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (tip) tip.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape') closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
